import type {
  MarginInventoryChange,
  MarginInventoryHistoryResponse,
  MarginTerm,
} from "@yutai/shared"

// 在庫の増減表示と、履歴表・グラフ用の整形（純粋関数）。

export interface ChangeLabel {
  direction: "up" | "down"
  /** 増減の絶対値 */
  amount: number
  /** 変化率（%）。from が 0 のときは計算できないので null */
  percent: number | null
}

export function describeChange(change: MarginInventoryChange): ChangeLabel {
  const diff = change.to - change.from
  return {
    direction: diff > 0 ? "up" : "down",
    amount: Math.abs(diff),
    percent: change.from === 0 ? null : Math.round((Math.abs(diff) / change.from) * 1000) / 10,
  }
}

export interface HistoryColumn {
  date: string
  quantities: Record<MarginTerm, number | null>
}

/** 14日・無期限の履歴を日付でまとめる（新しい日付が先頭） */
export function buildHistoryColumns(history: MarginInventoryHistoryResponse): HistoryColumn[] {
  const byDate = new Map<string, HistoryColumn>()
  for (const term of ["14d", "unlimited"] as const) {
    for (const p of history[term]) {
      const col = byDate.get(p.date) ?? {
        date: p.date,
        quantities: { "14d": null, unlimited: null },
      }
      col.quantities[term] = p.quantity
      byDate.set(p.date, col)
    }
  }
  return [...byDate.values()].sort((a, b) => b.date.localeCompare(a.date))
}

/** 年ごとの列数（表ヘッダの年セルの colSpan 用）。columns は新しい順 */
export function groupByYear(columns: HistoryColumn[]): { year: string; count: number }[] {
  const groups: { year: string; count: number }[] = []
  for (const c of columns) {
    const year = c.date.slice(0, 4)
    const last = groups[groups.length - 1]
    if (last?.year === year) last.count++
    else groups.push({ year, count: 1 })
  }
  return groups
}
